import React, { useContext } from "react";
import {
  Container,
  Grid2,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { LangContext } from "../../LanguageProvider";

const courses = [
  {
    id: 1,
    title: "Программирование на Python",
    description: "Основы программирования и разработка приложений на Python.",
    duration: "3 месяца",
  },
  {
    id: 2,
    title: "Веб-разработка",
    description: "HTML, CSS, JavaScript и основы создания сайтов.",
    duration: "4 месяца",
  },
  {
    id: 3,
    title: "Графический дизайн",
    description: "Работа с графическими редакторами и создание дизайнов.",
    duration: "2 месяца",
  },
  {
    id: 4,
    title: "Базы данных",
    description: "Основы SQL и управление базами данных.",
    duration: "3 месяца",
  },
  // Add more courses as needed
];

export default function Courses() {
  const { translations } = useContext(LangContext);
  return (
    <Container sx={{ paddingTop: { xs: 4, md: 10 } }}>
      <Typography variant="h4" gutterBottom align="center" >
        Курсы в колледже
      </Typography>
      <Grid2 container spacing={4} sx={{marginTop: 5}}>
        {courses.map(course => (
          <Grid2 size={{ xs: 12, sm: 6, md: 6 }} key={course.id}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {course.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {course.description}
                </Typography>
                <Typography variant="body2" color="text.primary">
                  Длительность: {course.duration}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: 2 }}>
                  {translations["podrobniy"]}{" "}
                </Button>
              </CardContent>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Container>
  );
}
